class ct_success_wrapper extends HTMLElement {
  constructor() {
    super();
  }
  launchMessage(message) {
    this.innerText = message;
    this.style.bottom = "15px";
    setTimeout(() => {
      this.innerText = "";
      this.style.bottom = "-100%";
    }, 3500);
  }
}
customElements.define("ct-success-wrapper", ct_success_wrapper);